import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const SUPPORTING_DOC_DELETE_REQUEST = 'SUPPORTING_DOC_DELETE_REQUEST';
export const SUPPORTING_DOC_DELETE_SUCCESS = 'SUPPORTING_DOC_DELETE_SUCCESS';
export const SUPPORTING_DOC_DELETE_FAILURE = 'SUPPORTING_DOC_DELETE_FAILURE';
export const NO_FORM_DOC_DELETE_SUCCESS = 'NO_FORM_DOC_DELETE_SUCCESS';

function requestSupportingDocDelete(id) {
  return {
    type: SUPPORTING_DOC_DELETE_REQUEST,
    isDeletingSupportingDocId: id,
  };
}

function receiveSupportingDocDelete(id) {
  return {
    type: SUPPORTING_DOC_DELETE_SUCCESS,
    isDeletingSupportingDocId: id,
  };
}

function rejectSupportingDocDelete(supportingDocError) {
  return {
    type: SUPPORTING_DOC_DELETE_FAILURE,
    isDeletingSupportingDocId: null,
    supportingDocError,
  };
}

function noFormDocDeletedSuccess() {
  return {
    type: NO_FORM_DOC_DELETE_SUCCESS,
    deletedNoFormDoc: undefined
  };
}

export function deleteSupportingDoc(docId) {
  return (dispatch) => {
    dispatch(requestSupportingDocDelete(docId));

    const promise = () => ApiService
      .deleteSupportingDoc(docId)
      .then((_response) => {
        dispatch(receiveSupportingDocDelete(docId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const status = error.response && error.response.data && error.response.data.code;
          if (status !== 401) {
            dispatch(handleException(error, rejectSupportingDocDelete, true));
          }
        }
      });
    return promise();
  };
}

export function noFormDocDeleted() {
  return (dispatch) => {
    dispatch(noFormDocDeletedSuccess());
  };
}
